import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup} from '@angular/forms';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/map';
import { RestService } from '../../shared/rest.service';
import { UbicacionesService } from './service/ubicaciones.service';
import { Observable } from 'rxjs/Observable';
import { NgxSpinnerService } from 'ngx-spinner';
import { setting } from '../../../../setting';
import { Store } from '@ngrx/store';
import { AppState } from 'app/core/profiles/storeProfile';
import { selectPermissions, selectRoles } from 'app/core/profiles/profiles.selectors';
import CssFilterConverter from "css-filter-converter";

@Component({
    selector: 'usb-search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.scss'],
    providers: [UbicacionesService],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBoxComponent implements OnInit {

    @Input() form: FormGroup;
    @Output() payload = new EventEmitter<any>();
    @Output() results = new EventEmitter<any>();
    @Output() isLoading = new EventEmitter<boolean>();
    @Output() origin = new EventEmitter<any>();
    @Input() _close: boolean;
    @Output() modal = new EventEmitter<string>();
    _roomQty: any;
    rooms: any[];
    _resultsQuery: any;
    tab: string;
    isActive: boolean = false;
    getClientsSettingAppBooking: any;
    activeBtn: string = 'hotels';
    private readonly disabledTabs: Set<string> = new Set(['FLIGHTS','MULTIDESTINO', 'PACKAGES']);
    public routeUploadFile: any;
    public sectionSearchBox: any;
    public moduleProfile: any[] = [];
    public searchItineraryAccess: boolean = false;
    public imageBackground: string;
    @Input() reloadCategories: boolean = true;

    // Whitelist of tab IDs the SearchBoxComponent knows how to handle.
    private readonly VALID_TAB_IDS: ReadonlySet<string> = new Set<string>([
      'HOTELS',
      'FLIGHTS',
      'EXPERIENCIAS',
      'TRANSPORTE',
      'MULTIDESTINO',
      'TICKETS',
      'CAR',
      'PACKAGES',
      'INSURANCE',
    ]);

      private filterCache = new Map<string, string>();

    //CategoryId's tours
    category = {
      ski:4,
      experience: 6,
      guide:7,
      tickets: 9,
    }



    roles$: Observable<string[]>;
    permissions$: Observable<string[]>;
    permissionsMap: { [key: string]: boolean } = {};

constructor(
        private _restService: RestService,
        public spinnerService:NgxSpinnerService,
        private store: Store<AppState>,
        private cdr: ChangeDetectorRef
    ) {
      this.tab = 'HOTELS';
      this.activeBtn = 'HOTELS';
      this.routeUploadFile =  setting.routeUploadFile;

    }

    ngOnInit() {
      this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
      this.permissions$ = this.store.select(selectPermissions);
      // Despacha las acciones para cargar roles y permisos
      // this.store.dispatch({ type: '[Auth] Load Permissions]' });

      this.permissions$.subscribe(permissions => {
        this.permissionsMap = this.createPermissionsMap(permissions);
      });
        this._roomQty = [];
        this.rooms = [];
        this.initResultQuery('Please perform a search');
        this.routeUploadFile =  setting.routeUploadFile;
        this.sectionSearchBox = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.section_search_box);
        const tabFromCart = sessionStorage.getItem('home-tab-from-cart');
        if (tabFromCart) {
          this.tab = tabFromCart;
          this.activeBtn = tabFromCart;
          sessionStorage.removeItem('home-tab-from-cart');
        }
        this._restService.optionsTab$.next(this.tab);
        this.imageBackground = this.getBackgroundImageUrl();
    }

    createPermissionsMap(permissions: any[]): { [key: string]: any } {
      const map: { [key: string]: any } = {};
      permissions.forEach((permission) => {
        map[permission.name] = permission;
      });
      return map;
    }

    private getBackgroundImageUrl(): string {
      return `url("${this.routeUploadFile.sectionSearchBox?.background_image}")`;
    }

    selectTab(option: string) {
      if (!option || this.disabledTabs.has(option)) {
          return;
      }
      if (option === this.tab) {
          return;
      }
      this._restService.optionsTab$.next(option);
      this.tab = option;
      this.activeBtn = option;
      this.cdr.markForCheck();
    }

    initResultQuery(message: any) {
        this._resultsQuery = [];
        this._resultsQuery.noResultMessage = message;
        this.results.emit(this._resultsQuery);
    }
    _onPayload(payload: any) {
        this.payload.emit(payload);
    }

    _onResults(results: any) {
        this.results.emit(results);
    }

    _onLoading(isLoading: boolean) {
        this.isLoading.emit(isLoading);
    }
    _onOrigin(origin: any) {
      //  console.log("console origin ", origin);
        this.origin.emit(origin);

    }
    openModal($event) {
        this.modal.emit($event);
    }

    changeActiveBtn(btn: string) {
      this.activeBtn = btn;
    }

getAlertFilter(item: any): string {
  if (!item) return '';

  // Si el item NO es el activo, devolver filtro blanco (sin color)
  if (item !== this.activeBtn) {
    return this.getWhiteFilter();
  }

  // Si es el activo, aplicar el color
  return this.getColorFilter(this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1);
}

private getWhiteFilter(): string {
  // Filtro para blanco (sin color)
  return 'brightness(0) invert(1)';
}

private getColorFilter(color: string): string {
  if (!color) return '';

  const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });
  const tempFilterStr = Object.keys(tempFilterObj)
    .map(key => `${key}(${tempFilterObj[key]})`)
    .join(" ");

  const colorRegex = /color\((.*)\)/;
  const colorMatch = tempFilterStr.match(colorRegex);
  return colorMatch ? colorMatch[1] : "";
}
  }
